"use client";

import createSvgIcon from "./utils/createSvgIcon.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "M2 7h4v10H2zm5 12h10V5H7zM18 7h4v10h-4z"
}), 'ViewCarouselSharp');